import { describe } from 'vitest';
import { buildFn } from './describe.utils';
import type {
  DescribeFn,
  DescribeFnOptional,
  DescribeFnOptionalParams,
  DescribeFnParams,
  ReturnIf,
  ReturnIfFalse,
  ReturnIfTrue,
} from './types';

// #region Simple Extensions
export function describe_cli(...[invite, fn, options]: DescribeFnParams) {
  const _fn = buildFn(fn);
  return describe(invite, _fn, options);
}

describe_cli.todo = ((invite, fn, options) => {
  const _fn = buildFn(fn);
  return describe.todo(invite, _fn, options);
}) as DescribeFnOptional;

describe_cli.skip = ((invite, fn, options) => {
  const _fn = buildFn(fn);
  return describe.skip(invite, _fn, options);
}) as DescribeFnOptional;

describe_cli.only = ((invite, fn, options) => {
  const _fn = buildFn(fn);
  return describe.only(invite, _fn, options);
}) as DescribeFn;

describe_cli.sequential = ((invite, fn, options) => {
  const _fn = buildFn(fn);
  return describe.sequential(invite, _fn, options);
}) as DescribeFn;

describe_cli.concurrent = ((invite, fn, options) => {
  const _fn = buildFn(fn);
  return describe.concurrent(invite, _fn, options);
}) as DescribeFn;

describe_cli.shuffle = ((invite, fn, options) => {
  const _fn = buildFn(fn);
  return describe.shuffle(invite, _fn, options);
}) as DescribeFn;
// #endregion

// #region Hooks
const useTrue = (): ReturnIfTrue => {
  function _true(...[invite, fn, options]: DescribeFnParams) {
    return describe_cli(invite, fn, options);
  }

  _true.skip = describe_cli.skip;
  _true.todo = describe_cli.todo;
  _true.only = describe_cli.only;
  _true.concurrent = describe_cli.concurrent;
  _true.sequential = describe_cli.sequential;
  _true.shuffle = describe_cli.shuffle;

  return _true;
};

const useFalse = (): ReturnIfFalse => {
  function _false(...[invite, fn, options]: DescribeFnOptionalParams) {
    return describe_cli.skip(invite, fn, options);
  }

  _false.skip = describe_cli.skip;
  _false.todo = describe_cli.todo;

  return _false;
};
// #endregion

// #region Conditionnal extensions
describe_cli.runIf = <T extends boolean>(cond: T) => {
  const _true = useTrue();
  const _false = useFalse();

  return (cond ? _true : _false) as ReturnIf<T>;
};

describe_cli.skipIf = <T extends boolean>(cond: T) => {
  const _true = useTrue();
  const _false = useFalse();

  return (cond ? _true : _false) as ReturnIf<T>;
};
// #endregion
